import { render, staticRenderFns } from "./PriceSchemeDetail.vue?vue&type=template&id=eb18e438&"
import script from "./PriceSchemeDetail.vue?vue&type=script&lang=js&"
export * from "./PriceSchemeDetail.vue?vue&type=script&lang=js&"
import style0 from "./PriceSchemeDetail.vue?vue&type=style&index=0&id=eb18e438&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports